import React, { Component } from "react";
import { Row, Col, Container, Alert } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import Loader from "react-loader-spinner";
import Header from "../components/header/header";
import Footer from "../components/statics/footer";
import * as UserProvider from "../providers/userProvider";
import * as action from "../actions/index";
import "./loginScreen.css";

var alert_types = {
  danger: "danger"
};
class LoginScreen extends Component {
  constructor() {
    super();
    this.state = {
      isCustomer: true,
      onChangeEmail: "",
      onChangePass: "",
      isAuth: false,
      showAlert: false,
      msg: ""
    };
    this.onDismiss = this.onDismiss.bind(this);
  }
  getEmail = event => {
    this.setState({ onChangeEmail: event.target.value });
  };
  getPass = event => {
    this.setState({ onChangePass: event.target.value });
  };
  validateFields() {
    if (this.state.onChangeEmail != "" && this.state.onChangePass != "") {
      return true;
    } else {
      return false;
    }
  }
  authUser = event => {
    event.preventDefault();
    if (this.validateFields()) {
      this.props.doLogin(this.state.onChangeEmail, this.state.onChangePass);
    } else {
      this.props.doSetLoginError("Preencha todos os campos");
    }
  };
  renderLoading() {
    return (
      <div
        style={{
          right: 0,
          display: "flex",
          position: "absolute",
          backgroundColor: "rgba(0,0,0,0.1)",
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          left: 0,
          top: 0,
          zIndex: 99
        }}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height="80"
          width="80"
          margin-top="20"
        />
      </div>
    );
  }
  onDismiss() {
    this.props.doSetLoginError("");
  }
  renderAlert() {
    return (
      <Alert color={alert_types.danger} toggle={this.onDismiss}>
        {this.props.loginError}
      </Alert>
    );
  }
  render() {
    if (this.props.userInfo.token) {
      if (this.props.userInfo.isProfessional) {
        return <Redirect to={"/profile-professional"} />;
      }
      return <Redirect to={"/profile"} />;
    }
    return (
      <div>
        {/* <Header /> */}
        <div className="container-form">
          <Container>
            <Col className="login-container">
              <h4>Olá! Entre em sua conta</h4>
              <form
                onSubmit={this.authUser.bind(this)}
                className="generic-form"
              >
                {this.props.loginError ? this.renderAlert() : null}
                {this.props.isLoading === false ? null : this.renderLoading()}
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control input-container"
                    id="email"
                    aria-describedby="emailHelp"
                    placeholder="Digite seu e-mail"
                    onChange={this.getEmail}
                  ></input>
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control input-container"
                    id="password"
                    placeholder="Digite sua senha"
                    onChange={this.getPass}
                  ></input>
                </div>
                <div className="mt-3 mb-3">
                  <Row className="justify-content-center">
                    <Link
                      className="lb-forgot-password"
                      to={"/recuperar-senha"}
                    >
                      {" "}
                      Esqueci minha Senha{" "}
                    </Link>
                  </Row>
                  <Row className="justify-content-center mt-3">
                    <button className="btn-form" type="submit" value="Login">
                      Entrar
                    </button>
                  </Row>
                </div>
                <Link className="text-dark lb-create-account" to={"/signup"}>
                  {" "}
                  Criar conta{" "}
                </Link>
              </form>
            </Col>
          </Container>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    doLogin: (email, password) =>
      dispatch(UserProvider.signIn(email, password)),
    doSetLoginError: error => dispatch(action.setLoginError(error))
  };
};
const mapStateToProps = state => {
  return {
    isLoading: state.user.isLoading,
    loginError: state.user.loginError,
    userInfo: state.user.userInfo
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(LoginScreen);
